import { UserSummaryState } from "@idw-types/state/user-summary-state";
import { CustomizeBySearchTypes } from "@enums/customize-by-search-types";
import { UserSummaryActionTypes, UserSummaryActions } from "../actions/user-summary-actions";
import { TimeRangeTypes } from "@enums/time-range-types";
import { getTimeRange } from "@utils/date-util";

export const initialUserSummaryState: UserSummaryState = {
    referenceData: {
        isLoading: false,
        companies: null,
        relyingParties: null,
        rpServices: null,
        workflows: null,
    },
    searchFilters: {
        customizeBySearchType: CustomizeBySearchTypes.VERIFICATION_SERVICE,
        companyId: null,
        rpServiceId: null,
        workflowId: null,
        startDate: getTimeRange(TimeRangeTypes.CURRENT_MONTH).startDate,
        endDate: getTimeRange(TimeRangeTypes.CURRENT_MONTH).endDate,
        timeRangeType: TimeRangeTypes.CURRENT_MONTH
    },
    searchResults: {
        searchDate: null,
        isLoading: false,
        monthlyUsersResult: null
    }
};

export const userSummaryReducer = (
    state: UserSummaryState = initialUserSummaryState,
    action: UserSummaryActions
): UserSummaryState => {
    switch (action.type) {
        case UserSummaryActionTypes.SET_USER_SUMMARY_REFERENCE_DATA_LOADING:
            return {
                ...state,
                referenceData: {
                    ...(action.payload.isLoading
                        ? { ...initialUserSummaryState.referenceData }
                        : { ...state.referenceData }),
                    isLoading: action.payload.isLoading
                }
            };
        case UserSummaryActionTypes.SET_USER_SUMMARY_REFERENCE_DATA:
            return {
                ...state,
                referenceData: {
                    ...action.payload.referenceData,
                    isLoading: false
                }
            };
        case UserSummaryActionTypes.SET_USER_SUMMARY_SEARCH_FILTERS:
            return {
                ...state,
                searchFilters: {
                    ...action.payload.searchFilters
                }
            };
        case UserSummaryActionTypes.SET_USER_SUMMARY_SEARCH_RESULTS_LOADING:
            return {
                ...state,
                searchResults: {
                    ...(action.payload.isLoading
                        ? { ...initialUserSummaryState.searchResults }
                        : { ...state.searchResults }),
                    isLoading: action.payload.isLoading
                }
            };
        case UserSummaryActionTypes.SET_USER_SUMMARY_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: {
                    isLoading: false,
                    monthlyUsersResult: action.payload.monthlyUsersResult,
                    searchDate: new Date()
                }
            };
        default:
            return state;
    }
};